let overlayHideAudioBoxCallback:((() => void) | null) = null;

import { getFirstParentSection } from "../../_helper";
import { showOverlay, hideOverlay } from "../../overlay/overlay";
import { overlayCloseHandlers } from "../../overlay/overlay";
import { showEmbeddingSections } from "../embedding/embedding";
import { hideElementContentHandler } from "../../_helper";
import { initMedia } from "../media/media";

import "./audioBox.css";

const initAudioBoxes = () => {
	document.querySelectorAll<HTMLElement>('audioMarkers-left box-button').forEach(audioButton => {
		const audioSection = getFirstParentSection(audioButton);
		if(!audioButton || !audioSection) {
			return;
		}

		// Find or create the audio box content
		let audioBoxContent = audioSection.querySelector<HTMLElement>('audio-box-content');
		if(!audioBoxContent) {
			// Get audio URL from the audio button's data attribute or parent element
			const audioURL = audioButton.getAttribute('data-audio-url') ||
				audioButton.querySelector('audio')?.src ||
				audioSection.querySelector('audio')?.src ||
				'';

			// Create audio box content if it doesn't exist
			audioBoxContent = document.createElement('audio-box-content');
			audioBoxContent.innerHTML = `
				<div class="audio-box-header">
					<box-button class="audio-box-close"></box-button>
					<h3>Audio</h3>
				</div>
				<div class="audio-box-body">
					${audioURL ? `<audio controls src="${audioURL}" preload="metadata"></audio>` : '<p>Keine Audiodatei vorhanden.</p>'}
				</div>
			`;
			audioSection.appendChild(audioBoxContent);

			// Initialize media controls for the audio element if it exists
			const audioElement = audioBoxContent.querySelector<HTMLAudioElement>('audio');
			if(audioElement) {
				initMedia(audioElement);
			}
		}

		let audioBoxVisible = false;
		let classRemoverTimer:ReturnType<typeof setTimeout> | null = null;

		const calcHeights = () => {
			if(audioBoxVisible) {
				const viewportHeight = window.innerHeight|0;
				const buttonHeight = audioButton.clientHeight|0;
				audioBoxContent.style.maxHeight = (viewportHeight - buttonHeight - 80) + "px"; // 80 == padding
			} else {
				audioBoxContent.style.maxHeight = "";
			}
		};

		const showAudioBox = () => {
			audioBoxVisible = true;
			const rect = audioButton.getBoundingClientRect();
			if(!audioButton.parentElement) {return;}

			// Set fixed height for parent to prevent content jumping
			audioButton.parentElement.style.height = ((rect.height|0)+8) + "px";

			const oldTop = (rect.top|0);
			const newTop = 32;
			const diff = oldTop - newTop;

			audioBoxContent.style.position = 'fixed';
			audioBoxContent.style.top = `${newTop}px`;
			audioBoxContent.style.left = '16px';
			audioBoxContent.style.right = '16px';
			audioBoxContent.style.zIndex = '3000';
			audioBoxContent.style.transform = `translateY(${diff}px)`;
			audioBoxContent.classList.add("active");

			// Force reflow
			audioBoxContent.getBoundingClientRect();

			audioBoxContent.style.transition = `transform 250ms`;
			window.requestAnimationFrame(() => {
				audioBoxContent.style.transform = `translateY(0)`;
			});

			showEmbeddingSections(audioBoxContent);
			showOverlay(audioSection);
			overlayHideAudioBoxCallback = hideAudioBox;

			// Ensure media controls are initialized for any audio elements
			const audioElement = audioBoxContent.querySelector<HTMLAudioElement>('audio');
			if(audioElement && !audioElement.parentElement?.querySelector('media-wrap')) {
				initMedia(audioElement);
			}

			if(classRemoverTimer) {
				window.clearTimeout(classRemoverTimer);
				classRemoverTimer = null;
			}
			calcHeights();
		};

		const hideAudioBox = () => {
			if(!audioButton.parentElement) {return;}

			audioBoxContent.classList.add("closing");
			audioBoxVisible = false;
			overlayHideAudioBoxCallback = null;

			if(classRemoverTimer === null) {
				classRemoverTimer = setTimeout(() => {
					audioBoxContent.classList.remove("closing");
					audioBoxContent.classList.remove("active");
					classRemoverTimer = null;
					audioBoxContent.setAttribute("style","");
					if(!audioButton.parentElement) {return;}
					audioButton.parentElement.style.height = "";
				}, 410);
			}

			hideElementContentHandler(audioBoxContent);
			const prect = audioButton.parentElement.getBoundingClientRect();
			const newTop = window.innerWidth > 800 ? 32 : 16;
			audioBoxContent.style.transform = `translateY(${(prect.top - newTop)|0}px)`;
			calcHeights();
		};

		audioButton.addEventListener("click", e => {
			e.preventDefault();
			e.stopPropagation();

			if(audioBoxVisible) {
				hideOverlay();
			} else {
				showAudioBox();
			}
		});

		// Add close button event listener
		const closeButton = audioBoxContent.querySelector<HTMLButtonElement>('.audio-box-close');
		if(closeButton) {
			closeButton.addEventListener("click", e => {
				e.preventDefault();
				e.stopPropagation();
				hideOverlay();
			});
		}
	});

	const hideCurAudioBox = () => {
		if(!overlayHideAudioBoxCallback) {return;}
		overlayHideAudioBoxCallback();
	};

	overlayCloseHandlers.push(hideCurAudioBox);
};

setTimeout(initAudioBoxes, 0);
